/* Boardwalk Vintage — theme.js
   Progressive enhancement only. Everything works without JS except quick add and drawers. */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const money = (cents) => {
    const fmt = window.JSM?.moneyFormat || '${{amount}}';
    const amount = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  };

  /* ---------- Scroll progress stripe ---------- */
  const stripe = $('.scroll-stripe');
  const header = $('.header');
  let lastY = 0;
  const onScroll = () => {
    const y = scrollY, h = document.documentElement.scrollHeight - innerHeight;
    if (stripe) stripe.style.setProperty('--progress', h > 0 ? (y / h).toFixed(4) : 0);
    if (header) {
      header.classList.toggle('is-compact', y > 80);
      header.classList.toggle('is-hidden', y > 400 && y > lastY && !document.body.classList.contains('menu-open'));
      document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
    }
    lastY = y;
  };
  addEventListener('scroll', onScroll, { passive: true }); onScroll();

  /* ---------- Reveal on scroll + split headlines ---------- */
  $$('[data-split]').forEach(el => {
    if (el.dataset.splitDone) return;
    const words = el.textContent.trim().split(/\s+/);
    el.innerHTML = words.map((w, i) => `<span class="split-word"><span style="--d:${i * 0.06}s">${w}</span></span>`).join(' ');
    el.dataset.splitDone = '1';
  });
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
  $$('[data-reveal], .stripe--draw, [data-split]').forEach(el => io.observe(el));

  /* ---------- Parallax (hero + feature media): CSS scroll timeline where supported, otherwise a scroll-driven update (no permanent rAF loop) ---------- */
  if (!reduce) {
    const px = $$('[data-parallax]');
    if (px.length && window.CSS?.supports?.('animation-timeline: view()')) {
      px.forEach(el => { el.style.setProperty('--px', parseFloat(el.dataset.parallax || 40) + 'px'); if (el.dataset.scale && el.dataset.scale !== '1') el.style.setProperty('--pxs', el.dataset.scale); el.classList.add('px-css'); });
    } else if (px.length) {
      let queued = false;
      const tick = () => {
        queued = false;
        px.forEach(el => {
          const r = el.getBoundingClientRect();
          if (r.bottom < 0 || r.top > innerHeight) return;
          const p = (r.top + r.height / 2 - innerHeight / 2) / innerHeight; // -1..1
          const amt = parseFloat(el.dataset.parallax || 40);
          const sc = el.dataset.scale && el.dataset.scale !== '1' ? ` scale(${el.dataset.scale})` : '';
          el.style.transform = `translate3d(0, ${(-p * amt).toFixed(1)}px, 0)${sc}`;
        });
      };
      const req = () => { if (!queued) { queued = true; requestAnimationFrame(tick); } };
      addEventListener('scroll', req, { passive: true }); addEventListener('resize', req); req();
    }
  }

  /* ---------- Pointer glow (badges, tiles) + badge tilt ---------- */
  if (!reduce && matchMedia('(hover:hover)').matches) {
    $$('.badge, .tile').forEach(el => {
      el.addEventListener('pointermove', (ev) => {
        const r = el.getBoundingClientRect();
        const x = (ev.clientX - r.left) / r.width, y = (ev.clientY - r.top) / r.height;
        el.style.setProperty('--mx', `${(x * 100).toFixed(1)}%`); el.style.setProperty('--my', `${(y * 100).toFixed(1)}%`);
        if (el.classList.contains('badge')) el.style.transform = `perspective(600px) rotateX(${((0.5 - y) * 14).toFixed(2)}deg) rotateY(${((x - 0.5) * 14).toFixed(2)}deg) translateY(-4px)`;
      });
      el.addEventListener('pointerleave', () => { el.style.transform = ''; });
    });
  }

  /* ---------- Header: mega menu ---------- */
  const backdrop = $('.mega-backdrop');
  const closeMegas = () => { $$('.nav-item.is-open').forEach(n => n.classList.remove('is-open')); $$('.mega.is-open').forEach(m => m.classList.remove('is-open')); backdrop?.classList.remove('is-open'); document.body.classList.remove('menu-open'); };
  $$('.nav-item[data-mega]').forEach(item => {
    const link = $('.nav-item__link', item); const mega = $(`#mega-${item.dataset.mega}`);
    if (!mega) return;
    let t;
    const open = () => { clearTimeout(t); closeMegas(); item.classList.add('is-open'); mega.classList.add('is-open'); backdrop?.classList.add('is-open'); document.body.classList.add('menu-open'); link.setAttribute('aria-expanded', 'true'); };
    const close = () => { t = setTimeout(closeMegas, 160); };
    item.addEventListener('mouseenter', open); item.addEventListener('mouseleave', close);
    mega.addEventListener('mouseenter', () => clearTimeout(t)); mega.addEventListener('mouseleave', close);
    link.addEventListener('click', (e) => { e.preventDefault(); item.classList.contains('is-open') ? closeMegas() : open(); });
  });
  backdrop?.addEventListener('click', closeMegas);
  addEventListener('keydown', e => { if (e.key === 'Escape') { closeMegas(); closeDrawers(); closeSearch(); } });

  /* ---------- Drawers ---------- */
  const dBackdrop = $('.drawer-backdrop');
  const closeDrawers = () => { $$('.drawer.is-open').forEach(d => { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); }); dBackdrop?.classList.remove('is-open'); document.body.style.overflow = ''; };
  const openDrawer = (id) => { closeDrawers(); const d = $(id); if (!d) return; d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); dBackdrop?.classList.add('is-open'); document.body.style.overflow = 'hidden'; $('button, a, input', d)?.focus(); };
  $$('[data-open-drawer]').forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); openDrawer(b.dataset.openDrawer); }));
  $$('[data-close-drawer]').forEach(b => b.addEventListener('click', closeDrawers));
  dBackdrop?.addEventListener('click', closeDrawers);

  /* ---------- Cart ---------- */
  const cartDrawer = $('#cart-drawer');
  const renderCart = (cart) => {
    $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); });
    if (!cartDrawer) return;
    const body = $('[data-cart-body]', cartDrawer), foot = $('[data-cart-foot]', cartDrawer);
    if (!cart.items.length) {
      body.innerHTML = `<div class="cart-empty"><span class="display h-md">Bag's empty.</span><p class="muted">Which is fine. The boardwalk was empty in February too.</p><a class="btn btn--primary" href="/collections/newest-drops">Shop new drops</a></div>`;
      foot.hidden = true; return;
    }
    foot.hidden = false;
    body.innerHTML = cart.items.map(it => `
      <div class="cart-line" data-key="${it.key}">
        <a href="${it.url}"><img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, '_200x200$1$2') : ''}" alt=""></a>
        <div style="display:flex;flex-direction:column;gap:6px">
          <div class="cart-line__title">${it.product_title}</div>
          <div class="muted" style="font-size:13px">${it.variant_title || ''}</div>
          <div class="qty"><button type="button" data-qty="-1" aria-label="Decrease">−</button><input type="number" value="${it.quantity}" min="0" aria-label="Quantity"><button type="button" data-qty="1" aria-label="Increase">+</button></div>
        </div>
        <div style="display:flex;flex-direction:column;align-items:flex-end;gap:8px"><span class="price">${money(it.final_line_price)}</span><button type="button" class="label" style="font-size:11px;color:var(--c-muted)" data-remove>Remove</button></div>
      </div>`).join('');
    $('[data-cart-subtotal]', cartDrawer).textContent = money(cart.total_price);
  };
  const renderCart0 = renderCart;
  const renderCartX = (cart) => { renderCart0(cart); document.dispatchEvent(new CustomEvent('jsm:cart', { detail: cart })); };
  const cartChange = async (key, quantity) => {
    const r = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
    renderCartX(await r.json());
  };
  cartDrawer?.addEventListener('click', (e) => {
    const line = e.target.closest('.cart-line'); if (!line) return;
    const input = $('input', line);
    if (e.target.dataset.qty) cartChange(line.dataset.key, Math.max(0, +input.value + +e.target.dataset.qty));
    if (e.target.hasAttribute('data-remove')) cartChange(line.dataset.key, 0);
  });
  cartDrawer?.addEventListener('change', (e) => { const line = e.target.closest('.cart-line'); if (line && e.target.matches('input')) cartChange(line.dataset.key, Math.max(0, +e.target.value)); });
  const refreshCart = async () => { const r = await fetch('/cart.js'); renderCartX(await r.json()); };
  if (cartDrawer) refreshCart();

  const toast = (msg) => {
    let t = $('.toast'); if (!t) { t = document.createElement('div'); t.className = 'toast'; document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-visible'); clearTimeout(t._t); t._t = setTimeout(() => t.classList.remove('is-visible'), 2600);
  };
  const flyToCart = (fromEl) => {
    if (reduce) return;
    const target = $('[data-cart-icon]'); if (!target || !fromEl) return;
    const a = fromEl.getBoundingClientRect(), b = target.getBoundingClientRect();
    const dot = document.createElement('div'); dot.className = 'fly';
    dot.style.left = a.left + a.width / 2 + 'px'; dot.style.top = a.top + a.height / 2 + 'px'; document.body.appendChild(dot);
    const dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
    dot.animate([{ transform: 'translate(0,0) scale(1)', opacity: 1 }, { transform: `translate(${dx * 0.5}px, ${dy - 120}px) scale(1.4)`, opacity: 1, offset: 0.5 }, { transform: `translate(${dx}px, ${dy}px) scale(.2)`, opacity: .6 }], { duration: 700, easing: 'cubic-bezier(.2,.8,.2,1)' }).onfinish = () => dot.remove();
  };
  const addToCart = async (form, btn) => {
    btn?.classList.add('is-loading');
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } });
      const data = await r.json();
      if (!r.ok) throw new Error(data.description || 'Could not add to bag');
      flyToCart(btn); document.dispatchEvent(new CustomEvent('jsm:added', { detail: { btn, form } }));
      await refreshCart();
      if (cartDrawer && window.JSM?.cartDrawer !== false) setTimeout(() => openDrawer('#cart-drawer'), 350); else toast('Added to your bag');
    } catch (err) { toast(err.message); }
    finally { btn?.classList.remove('is-loading'); }
  };
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form.matches('form[action*="/cart/add"]') && !form.hasAttribute('data-no-ajax')) { e.preventDefault(); addToCart(form, $('[type=submit]', form)); }
  });
  // quick add from cards
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-quick-add]'); if (!b) return;
    e.preventDefault();
    const f = document.createElement('form'); f.innerHTML = `<input name="id" value="${b.dataset.quickAdd}"><input name="quantity" value="1">`;
    addToCart(f, b);
  });

  /* ---------- Product form: variants, gallery, sticky ATC ---------- */
  $$('[data-product]').forEach(root => {
    const variants = JSON.parse($('[data-variants]', root)?.textContent || '[]');
    const idInput = $('input[name=id]', root); const priceEl = $('[data-price]', root); const cmpEl = $('[data-compare]', root);
    const btn = $('[data-atc]', root); const sticky = $('.sticky-atc');
    const optWraps = $$('[data-option]', root);
    const selected = () => optWraps.map(w => $('.is-active', w)?.dataset.value);
    const showImage = (id) => { const imgs = $$('.product__main img', root); const im = imgs.find(i => i.dataset.mediaId == id); if (!im) return; imgs.forEach(i => i.classList.remove('is-active')); im.classList.add('is-active'); $$('.product__thumbs button', root).forEach(t => t.classList.toggle('is-active', t.dataset.mediaId == id)); };
    const update = () => {
      const sel = selected();
      const v = variants.find(v => sel.every((s, i) => v.options[i] === s));
      // availability per option value
      optWraps.forEach((w, i) => $$('[data-value]', w).forEach(el => {
        const test = sel.slice(); test[i] = el.dataset.value;
        const ok = variants.some(v => v.available && test.every((s, k) => k === i || !s ? v.options[i] === el.dataset.value && (k === i || v.options[k] === s) : v.options[k] === s));
        el.toggleAttribute('disabled', !ok);
      }));
      optWraps.forEach(w => { const lbl = $('[data-selected-label]', w); if (lbl) lbl.textContent = $('.is-active', w)?.dataset.value || ''; });
      if (!v) { btn.disabled = true; $('.btn__text', btn).textContent = 'Unavailable'; return; }
      idInput.value = v.id; btn.disabled = !v.available; $('.btn__text', btn).textContent = v.available ? 'Add to bag' : 'Sold out';
      if (priceEl) priceEl.textContent = money(v.price);
      if (cmpEl) { cmpEl.hidden = !(v.compare_at_price > v.price); cmpEl.textContent = v.compare_at_price ? money(v.compare_at_price) : ''; }
      if (v.featured_media) showImage(v.featured_media.id);
      const url = new URL(location); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      if (sticky) { $('[data-sticky-price]', sticky).textContent = money(v.price); }
    };
    optWraps.forEach(w => w.addEventListener('click', e => { const el = e.target.closest('[data-value]'); if (!el || el.disabled) return; $$('[data-value]', w).forEach(x => x.classList.remove('is-active')); el.classList.add('is-active'); update(); }));
    $$('.product__thumbs button', root).forEach(t => t.addEventListener('click', () => showImage(t.dataset.mediaId)));
    $$('.qty button', root).forEach(b => b.addEventListener('click', () => { const i = $('input', b.parentElement); i.value = Math.max(1, +i.value + +b.dataset.qty); }));
    if (sticky && btn) {
      const so = new IntersectionObserver(([e]) => sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0), { threshold: 0 });
      so.observe(btn);
      $('[data-sticky-atc]', sticky)?.addEventListener('click', () => btn.click());
    }
    update();
  });

  /* ---------- Instagram: pause/scrub controls ---------- */
  $$('.ig').forEach(ig => {
    const track = $('.ig__track', ig);
    $('[data-ig-pause]', ig)?.addEventListener('click', (e) => { ig.classList.toggle('is-paused'); e.currentTarget.setAttribute('aria-pressed', ig.classList.contains('is-paused')); });
    $$('video', ig).forEach(v => { v.muted = true; ig.addEventListener('mouseenter', () => v.play().catch(() => {})); ig.addEventListener('mouseleave', () => v.pause()); });
  });

  /* ---------- Predictive search ---------- */
  const so = $('.search-overlay'); const si = $('.search-box input'); let st;
  const closeSearch = () => { so?.classList.remove('is-open'); document.body.style.overflow = ''; };
  $$('[data-open-search]').forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); so?.classList.add('is-open'); document.body.style.overflow = 'hidden'; setTimeout(() => si?.focus(), 50); }));
  $$('[data-close-search]').forEach(b => b.addEventListener('click', closeSearch));
  si?.addEventListener('input', () => {
    clearTimeout(st); const q = si.value.trim(); const out = $('.search-results');
    if (q.length < 2) { out.innerHTML = ''; return; }
    st = setTimeout(async () => {
      const r = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection,query&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag`);
      const d = (await r.json()).resources.results;
      const prods = (d.products || []).map(p => `<a class="card" href="${p.url}"><div class="card__media"><img class="main" src="${p.featured_image?.url ? p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/, '_400x400$1$2') : ''}" alt=""></div><div class="card__title">${p.title.split(' - ')[0]}</div><span class="price">${p.price ? '$' + p.price : ''}</span></a>`).join('');
      const colls = (d.collections || []).map(c => `<a href="${c.url}">${c.title}</a>`).join('');
      const qs = (d.queries || []).map(c => `<a href="${c.url}">${c.styled_text}</a>`).join('');
      out.innerHTML = `<div><div class="label overline" style="margin-bottom:14px">Products</div><div class="search-results__products">${prods || '<p class="muted">Nothing yet. Try a town or a bar.</p>'}</div></div><div class="search-results__list"><div class="label overline" style="margin-bottom:14px">Towns and collections</div>${colls}${qs ? `<div class="label overline" style="margin:24px 0 14px">Suggestions</div>${qs}` : ''}<a href="/search?q=${encodeURIComponent(q)}" style="color:var(--c-rust);font-weight:700;margin-top:12px">See all results for "${q}"</a></div>`;
    }, 180);
  });


  /* ---------- Product row carousel ---------- */
  $$('[data-row]').forEach(row => {
    const track = $('[data-row-track]', row), prog = $('[data-row-progress]', row);
    const step = () => (track.firstElementChild?.getBoundingClientRect().width || 270) + 24;
    $('[data-row-prev]', row)?.addEventListener('click', () => track.scrollBy({ left: -step() * 2, behavior: 'smooth' }));
    $('[data-row-next]', row)?.addEventListener('click', () => track.scrollBy({ left: step() * 2, behavior: 'smooth' }));
    const upd = () => { const max = track.scrollWidth - track.clientWidth; const w = Math.max(10, (track.clientWidth / track.scrollWidth) * 100); prog?.style.setProperty('--w', w + '%'); prog?.style.setProperty('--x', max > 0 ? `${(track.scrollLeft / max) * (100 / w - 1) * 100}%` : '0'); };
    track.addEventListener('scroll', upd, { passive: true }); addEventListener('resize', upd); upd();
    // drag to scroll (desktop)
    let down = false, sx = 0, sl = 0;
    track.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse') return; down = true; sx = e.clientX; sl = track.scrollLeft; track.style.scrollSnapType = 'none'; });
    addEventListener('pointerup', () => { if (down) { down = false; track.style.scrollSnapType = ''; } });
    track.addEventListener('pointermove', e => { if (down) track.scrollLeft = sl - (e.clientX - sx); });
  });

  /* ---------- Instagram: live feed + hero reels (client-side, read-only token) ---------- */
  /* 2026-09-25: the feed is server-side (shop metafield jsm.instagram_feed, embedded by the IG section). No token in the browser. */
  const igEl = document.querySelector('script[data-ig-feed]');
  const igToken = igEl ? 'server' : null;
  const igFetch = async () => {
    if (igEl) { try { return JSON.parse(igEl.textContent) || []; } catch { return []; } }
    const key = 'jsm_ig_v1';
    try { const c = JSON.parse(sessionStorage.getItem(key) || 'null'); if (c && Date.now() - c.t < 30 * 60 * 1000) return c.data; } catch {}
    const fields = 'id,media_type,media_url,thumbnail_url,permalink,caption,children{media_type,media_url,thumbnail_url}';
    const tok = encodeURIComponent(igToken);
    let u;
    if (/^IG/.test(igToken)) {
      // Instagram-login token (graph.instagram.com)
      u = `https://graph.instagram.com/me/media?fields=${fields}&limit=30&access_token=${tok}`;
    } else {
      // Facebook-login token (User or Page). Resolve the IG professional account id unless set in theme settings.
      const G = 'https://graph.facebook.com/v23.0';
      let igId = window.JSM?.igUserId;
      if (!igId) {
        const me = await (await fetch(`${G}/me?fields=instagram_business_account&access_token=${tok}`)).json();
        igId = me?.instagram_business_account?.id;
        if (!igId) {
          const acc = await (await fetch(`${G}/me/accounts?fields=instagram_business_account&access_token=${tok}`)).json();
          igId = (acc?.data || []).find(p => p.instagram_business_account)?.instagram_business_account?.id;
        }
        if (!igId) throw new Error('ig: no Instagram professional account linked to this token');
      }
      u = `${G}/${igId}/media?fields=${fields}&limit=30&access_token=${tok}`;
    }
    const r = await fetch(u); if (!r.ok) throw new Error('ig ' + r.status);
    const data = (await r.json()).data || [];
    try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), data })); } catch {}
    return data;
  };
  const heroFallback = () => { const h = $('.hero'); if (!h) return; h.classList.remove('hero--reels'); $('.hero__reels', h)?.remove(); $('.hero__reel-cap', h)?.remove(); };
  if (igToken) (async () => {
    let media = [];
    try { media = await igFetch(); } catch (e) { console.warn('Instagram feed unavailable', e); heroFallback(); return; }
    // Meta omits media_url for videos containing licensed music; those reels can only be shown as their thumbnail.
    // Loop only the opening seconds of each reel (Theme settings → Instagram → clip length; 0 = whole reel).
    const clip = +window.JSM?.reelClip || 0;
    const clipLoop = (v) => { if (clip > 0) v.addEventListener('timeupdate', () => { if (v.currentTime >= clip) v.currentTime = 0; }); };
    const picUrl = m => m.media_type === 'VIDEO' ? m.thumbnail_url : (m.media_type === 'CAROUSEL_ALBUM' && m.children?.data?.[0]?.media_url) || m.media_url;
    const REEL_BADGE = '<span class="ig__badge"><svg class="icon icon--sm" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="4"/><path d="M3 9h18M8 3l3 6M14 3l3 6"/><path d="M10.5 12.5v5l4-2.5z" fill="currentColor"/></svg></span>';
    // feed tiles
    $$('.ig').forEach(ig => {
      const track = $('.ig__track', ig); if (!track) return;
      const limit = +ig.dataset.igLimit || 12;
      // like the GSC app: skip reels Meta returns without a video file (licensed audio) so every reel shown plays
      const items = media.filter(m => m.media_type === 'VIDEO' ? !!m.media_url : !!picUrl(m)).slice(0, limit);
      if (!items.length) return;
      const tile = (m, hidden) => {
        const isVideo = m.media_type === 'VIDEO', playable = isVideo && m.media_url;
        const cap = (m.caption || '').replace(/[<>]/g, '').slice(0, 140);
        const media_ = playable ? `<video src="${m.media_url}" data-poster="${m.thumbnail_url || ''}" muted loop playsinline preload="none"></video>` : `<img src="${picUrl(m)}" alt="" loading="lazy" width="600" height="600">`;
        return `<a class="ig__tile" href="${m.permalink}" target="_blank" rel="noopener" ${hidden ? 'aria-hidden="true" tabindex="-1"' : ''}>${media_}${(isVideo || m.reel) ? REEL_BADGE : ''}${cap ? `<span class="ig__cap"><span>${cap}</span></span>` : ''}</a>`;
      };
      track.innerHTML = items.map(m => tile(m, false)).join('') + items.map(m => tile(m, true)).join('');
      // reels play (muted, looped) while their tile is on screen; off-screen tiles pause to save decode work
      const pio = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { const v = e.target; if (v.dataset.poster) v.poster = v.dataset.poster; pio.unobserve(v); } }), { rootMargin: '400px' });
      const vio = new IntersectionObserver(es => es.forEach(e => { const v = e.target; if (e.isIntersecting) { v.preload = 'auto'; v.play().catch(() => {}); } else v.pause(); }), { threshold: 0.15 });
      $$('video', track).forEach(v => { v.muted = true; clipLoop(v); pio.observe(v); vio.observe(v); });
    });
    // hero reels: the newest posts in order. A reel plays when Meta returns its video; reels with licensed audio
    // come back without media_url (copyright rule) and are shown as their cover with a slow drift instead.
    const reels = $('[data-hero-reels]');
    if (reels && !reels.classList.contains('is-ready')) {
      const want = matchMedia('(max-width:749px)').matches ? 1 : (+reels.dataset.heroReels || 3);
      const mode = reels.dataset.heroMode || 'playable';
      let pool = media.filter(m => (m.media_type === 'VIDEO' && m.media_url) || picUrl(m));
      if (mode !== 'newest') pool = pool.filter(m => m.media_type === 'VIDEO' && m.media_url).concat(pool.filter(m => m.media_type !== 'VIDEO'));
      const slots = $$('.reel', reels);
      if (!pool.length) { heroFallback(); return; }
      const live = (slot) => { slot.classList.add('is-live'); reels.classList.add('is-ready'); };
      const fill = (slot) => {
        const m = pool.shift(); if (!m) { slot.remove(); return; }
        const v = $('video', slot);
        if (m.media_type === 'VIDEO' && m.media_url && v) {
          v.poster = m.thumbnail_url || ''; v.preload = 'auto'; v.muted = true; clipLoop(v);
          v.addEventListener('playing', () => live(slot), { once: true });
          v.addEventListener('error', () => { v.remove(); fill(slot); }, { once: true });
          v.addEventListener('canplay', () => v.play().catch(() => {}));
          v.src = m.media_url; v.play().catch(() => {});
        } else {
          v?.remove();
          const img = new Image(); img.className = 'reel__img'; img.alt = ''; img.decoding = 'async';
          img.onload = () => live(slot); img.onerror = () => fill(slot); img.src = picUrl(m); slot.appendChild(img);
          if (m.media_type === 'VIDEO') slot.insertAdjacentHTML('beforeend', '<span class="reel__still" title="Reel with licensed audio: Instagram only shares the cover">' + REEL_BADGE + '</span>');
        }
      };
      slots.forEach((slot, i) => { if (i >= want) { slot.remove(); return; } fill(slot); });
      if (want < 3) reels.style.gridTemplateColumns = `repeat(${want},minmax(0,1fr))`;
    }
  })();

  /* ---------- Card hover image (2026-09-25): only hover-capable devices fetch it ---------- */
  if (matchMedia('(hover:hover)').matches) {
    const altImgs = (root = document) => $$('a.card__media[data-alt]', root).forEach(a => {
      if ($('img.alt', a)) return;
      const i = new Image(); i.className = 'alt'; i.alt = ''; i.loading = 'lazy'; i.decoding = 'async'; i.width = 600; i.height = 600; i.src = a.dataset.alt;
      a.insertBefore(i, $('img.main', a));
    });
    altImgs();
  }

  /* ---------- Collection sort ---------- */
  $('[data-sort]')?.addEventListener('change', (e) => { const u = new URL(location); u.searchParams.set('sort_by', e.target.value); u.searchParams.delete('page'); location = u; });
})();
